import React from 'react';

import { FilterDataTypes } from '../../../../store/types';
import { useFiltersDispatch, useFiltersState } from '../../../../store/hooks';
import { history } from '../../../../store/reducers';
import { ParamWrapperBasicPropsType, ParamWrapperPropsType } from './types';
import { useRouter } from '../../../../helpers/customHooks';
import { FILTER_KEYS } from 'config/constants';

export const ParamWrapper = <T1 extends FilterDataTypes, T2 extends ParamWrapperBasicPropsType>
({
   Component,
   toUrlSearchParam,
   fromUrlSearchParam,
   filterKey,
   props
 }: ParamWrapperPropsType<T1, T2>) => {
  const { urlPersistent, forceScope, otherScopes } = props;
  const { pathname, search, specificScope: specificScopePrime } = useRouter();
  const specificScope = forceScope || specificScopePrime;
  const { [filterKey]: filterData } = useFiltersState(specificScope, filterKey);
  const { changeFilterData } = useFiltersDispatch();
  const urlSearchParams = new URLSearchParams(search);
  const param: T1 = fromUrlSearchParam(urlSearchParams.get(filterKey) || '', props);
  if (!urlPersistent) {
    if (filterData === undefined && param) {
      changeFilterData(param, filterKey, specificScope, otherScopes)();
      return null;
    }
    return (
      <Component
        {...props}
        changeFilterDataWrapped={(itemSelected: T1) => changeFilterData(itemSelected, filterKey, specificScope, otherScopes)}
      />
    );
  }
  if (JSON.stringify(filterData || '_') !== JSON.stringify(param)) { // fix data of redux
    changeFilterData(param, filterKey, specificScope, otherScopes)();
    return null;
  }
  
  const params = {
    ...props,
    ...{
      changeFilterDataWrapped: (itemSelected: T1) => () => {
        const param = toUrlSearchParam(itemSelected, props);
        if (param) {
          urlSearchParams.set(filterKey, param);
        } else {
          urlSearchParams.delete(filterKey);
        }
        history.push({ pathname: pathname, search: `?${urlSearchParams.toString()}` });
      }
    }
  };
  return <Component {...params} />;
};

export * from './types';
